import React, { forwardRef } from "react";
import { actions, RichToolbar } from "react-native-pell-rich-editor";
import { Text } from 'react-native';
import handleImageUpload from "@utils/handleCamera";
import { Platform } from "react-native";

interface editorProps {
  vertical?: boolean;
  backgroundColor?: string;
  style?: object;
  actions?: any[];
  iconTint?: string;
  omitImage?: boolean;
  omitVideo?: boolean;
  iconSize?: number;
}

const ToolBarComponent = forwardRef((props: editorProps, ref) => {
  const { omitImage, vertical, omitVideo, actions: customActions, iconTint, iconSize: customIconSize } = props;
  const handleHead = ({ tintColor }) => <Text style={{ color: tintColor || 'white', fontWeight: 'bold', fontSize: 16 }}>H1</Text>
  const handleHead2 = ({ tintColor }) => <Text style={{ color: tintColor || 'white', fontWeight: 'bold', fontSize: 14 }}>H2</Text>
  const handleHead3 = ({ tintColor }) => <Text style={{ color: tintColor || 'white', fontSize: 20, fontWeight: 'bold' }}>f</Text>

  console.log('EditorToolbar ref has current property:', ref && typeof ref === 'object' && 'current' in ref);

  return (
    <RichToolbar
      getEditor={() => (ref && typeof ref === 'object' && 'current' in ref ? (ref as any).current : (ref as any))} // Return editor instance from ref
      {...(vertical ? { horizontal: false } : {})}
      flatContainerStyle={{
        gap: vertical ? 15 : (customIconSize && customIconSize < 24 ? 4 : 8),
        paddingVertical: vertical ? 10 : (customIconSize && customIconSize < 24 ? 2 : 4),
        paddingHorizontal: vertical ? 5 : (customIconSize && customIconSize < 24 ? 2 : 6),
        borderTopStartRadius: 20,
        borderTopEndRadius: !vertical && 20,
        borderBottomLeftRadius: vertical && 20,
        backgroundColor: 'transparent',
        borderWidth: 0,
        shadowColor: 'transparent',
        elevation: 0
      }}
      selectedButtonStyle={{
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        borderWidth: 0,
        borderRadius: 8,
        marginVertical: vertical ? 4 : (customIconSize && customIconSize < 24 ? 1 : 2),
        marginHorizontal: customIconSize && customIconSize < 24 ? 1 : 2,
        padding: customIconSize && customIconSize < 24 ? 2 : 4
      }}
      unselectedButtonStyle={{
        backgroundColor: 'transparent',
        borderWidth: 0,
        borderRadius: 8,
        marginVertical: vertical ? 4 : (customIconSize && customIconSize < 24 ? 1 : 2),
        marginHorizontal: customIconSize && customIconSize < 24 ? 1 : 2,
        padding: customIconSize && customIconSize < 24 ? 2 : 4,
        left: -3,
        color: 'white',
      }}
      selectedIconTint="white"
      iconTintColor="white"
      disabledIconTint="rgba(255, 255, 255, 0.5)"
      actions={customActions || [
        undefined,
        actions.undo,
        actions.setBold,
        actions.setItalic,
        actions.setUnderline,
        actions.fontSize,
        actions.fontName,
        actions.heading1,
        actions.heading2,
        actions.alignCenter,
        actions.insertBulletsList,
        actions.insertOrderedList,
        actions.insertLink,
        actions.code,
        actions.checkboxList,
        actions.setStrikethrough,
        !omitImage && actions.insertImage,
        !omitVideo && actions.insertVideo,
        undefined
      ]}
      iconMap={{ [actions.heading1]: handleHead, [actions.heading2]: handleHead2, [actions.fontName]: handleHead3 }}
      iconSize={customIconSize !== undefined ? customIconSize : (vertical ? 30 : 40)}
      itemStyle={{
        maxHeight: customIconSize !== undefined ? customIconSize + 4 : (vertical ? 35 : 40),
        justifyContent: 'center',
        alignItems: 'center'
      }}
      style={{
        flex: 1,
        minWidth: vertical ? 60 : '100%',
        maxWidth: vertical ? 50 : undefined,
        width: vertical ? 70 : '100%',
        height: vertical ? '100%' : 50,
        flexDirection: vertical ? 'column' : 'row',
        backgroundColor: props.backgroundColor || "#2196f3",
        borderWidth: 0,
        borderColor: 'transparent',
        shadowColor: 'transparent',
        elevation: 0,
        paddingVertical: vertical ? 20 : 10,
        paddingHorizontal: vertical ? 5 : 10,
        ...props.style
      }}
      onPressAddImage={() => {
        console.log('onPressAddImage called, ref:', ref);
        console.log('ref type:', typeof ref);
        // Handle both ref object and forwarded ref types
        if (ref && typeof ref === 'object' && 'current' in ref && ref.current) {
          handleImageUpload().then((image) => (ref.current as any).insertImage(image));
        } else if (ref && typeof ref === 'object') {
          // Direct instance case (fallback)
          handleImageUpload().then((image) => (ref as any).insertImage(image));
        }
      }}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
    />
  )
});

export default ToolBarComponent;
